/*
 * File: GetAllCourses.ts
 * Author: Austin Robinson
 * Date Created: 8/1/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { ErrorResponse, PostGreSQLInterval, privateApi } from 'api';

export interface GetCoursesParams {}

export interface Course {
  tenant_id: string;
  id: string;
  course_type: 'behind_the_wheel' | 'in_person' | 'synchronous_online' | 'fully_online';
  schedule_type: 'self_scheduled' | 'fixed' | 'manual' | 'no_schedule';
  title: string;
  description: string | null;
  created_at: string | null;
  created_by: string | null;
  updated_at: string | null;
  updated_by: string | null;
  section_count: number;
  typical_period_duration: PostGreSQLInterval | null;
  typical_period_capacity: number | null;
  typical_period_observation_capacity: number | null;
  typical_period_waitlist_capacity: number | null;
}

export type GetCoursesResult = Course[];

async function getCourses(_params: GetCoursesParams | undefined): Promise<GetCoursesResult> {
  // if (params === undefined) {
  //     return [];
  // }

  // make api call
  const result = await privateApi.get<GetCoursesResult>(`${import.meta.env.VITE_API_BASE_URL}/courses`);

  // return the data object
  return result.data;
}

const useGetCourses = createQuery<GetCoursesResult, GetCoursesParams, AxiosError<ErrorResponse>>({
  queryKey: ['courses'],
  fetcher: (variables) => getCourses(variables),
});

export { getCourses, useGetCourses };
